export default __webpack_public_path__ + "static/media/Meritlogo.b5091ba1.svg";